module.exports = __webpack_public_path__ + "img/50400.f1d20616.jpg";